import { counsellings_api_home_url } from 'mk/urls/functions';
import {
    COUNSELLINGS_HOME_LOAD,
    counsellingsHomeFetch,
    CounsellingsHomeFetchNormalizedResponse,
    CounsellingsHomeFetchRequestAction,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.actions';
import { TopicStats } from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.reducers';
import { forumUpdateComplaintsStatistics } from 'mk2/apps/forum/actions';
import {
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { normalizeError, XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('counsellings/CounsellingsHome.sagas');

interface ApiResponsePosts {
    body: {
        posts: PostEntity[];
        hasNext: number;
        hasPrevious: number;
        notificationsOn: number[];
        complaintsStatistics: ComplaintsStatisticsPerPost;
        topicStats: TopicStats;
        lastVisitCounts: {
            subscribedCounsellings: TopicStats;
        }
        counsellings: CounsellingEntity;
    };
}

function* load({ after, xhr }: CounsellingsHomeFetchRequestAction & XHRAction) {
    yield put(counsellingsHomeFetch.request(after));

    try {
        const response: ApiResponsePosts = yield call(
            () => xhr.get(counsellings_api_home_url(), { after }),
        );

        const normalizedResponse: CounsellingsHomeFetchNormalizedResponse = normalize(response.body, {
            posts: [PostSchema],
            followingTopics: [TopicSchema],
            topics: [TopicSchema],
            counsellings: [CounsellingSchema],
        });

        yield put(forumUpdateComplaintsStatistics(response.body.complaintsStatistics));
        yield put(counsellingsHomeFetch.success(
            after,
            response.body.hasNext,
            response.body.hasPrevious,
            response.body.notificationsOn,
            response.body.topicStats,
            response.body.lastVisitCounts.subscribedCounsellings,
            normalizedResponse,
        ));
    } catch (error) {
        logger.error(error);

        yield put(counsellingsHomeFetch.failure(after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(COUNSELLINGS_HOME_LOAD, load),
    ]);
}
